import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    data: {},
    masterStatus: [],
    employerStatusError: undefined
}

export const employerStatusSlice = createSlice({
    name: 'employerStatus',
    initialState,
    reducers: {
        employerStatusData: (state, action) => {
            state.data = action.payload.data;
            state.masterStatus = action.payload.masterStatus;
        },
        employerStatusDataFailed: (state, action) => {
            state.employerStatusError = action.payload
        }
    }
});

export const {
    employerStatusData,
    employerStatusDataFailed
} = employerStatusSlice.actions;

export default employerStatusSlice.reducer;
